import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('General');

export const MODEL_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Model.Name')
    .required()
    .minLength(1)
    .maxLength(55)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Model.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
];

export const MODEL_CONFIG = {
  entityName: 'Model',
  localizationKey: 'General::Entity.Model',
  fields: MODEL_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Models',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
